import { useParams } from 'react-router-dom';
import styles from '../Museum.module.scss';

export const About = ({ upPage }) => {
  const { lang } = useParams();
  const { content, img, toptitle, title, text, subtext } = upPage.acf.about;

  return (
    <section className={styles.about}>
      <div className="container">
        <div className={styles.about_body}>
          <div id="about" className={styles.about_query}></div>
          <div className={styles.about_content}>
            <div className={`${styles.about_content_body} ${!!img ? 'active' : ''}`}>
              {!!img ? (
                <>
                  <div className={styles.about_content_img}>
                    <img src={img} alt="about" />
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.about_content_icon}>
                    <div className={`${styles.about_content_icon_img} one`}>{content.icon_one}</div>
                    <div className={`${styles.about_content_icon_img} two`}>{content.icon_two}</div>
                  </div>
                  <div className={styles.about_content_text}>
                    <span>{content.text}</span>
                    <span>-{content.author}</span>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className={styles.about_info}>
            <h3 className={`${styles.about_info_toptitle} global-subtitle`}>{toptitle[lang]}</h3>
            <h2 className={`${styles.about_info_title} global-title`}>{title[lang]}</h2>
            <p className={`${styles.about_info_text} global-text`}>{text[lang]}</p>
            <p className={styles.about_info_subtext}>{subtext[lang]}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
